import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Create axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
});

// Add auth token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// API endpoints
export const cropAPI = {
  // Get crop by variety code (public endpoint)
  getCropByCode: (varietyCode, language = 'en') =>
    api.get(`/Crop/variety/${encodeURIComponent(varietyCode)}`, { params: { language } }),

  // Admin endpoints (require auth)
  getCrop: (id) =>
    api.get(`/Crop/${id}`),

  insertCrop: (cropData) =>
    api.post('/Crop/insert', cropData),

  updateCrop: (id, cropData) =>
    api.post(`/Crop/${id}`, cropData),

  deleteCrop: (id, undelete = 0) =>
    api.post(`/Crop/${id}/delete?undelete=${undelete}`),

  uploadPouchImage: (id, imageFile) => {
    const formData = new FormData();
    formData.append('file', imageFile);
    return api.post(`/Crop/${id}/upload-pouch-image`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  searchCrops: (query, language = 'en', limit = 50, isActive = null) => {
    const params = { language, limit };
    if (query) params.q = query;
    if (isActive !== null) params.isActive = isActive;
    return api.get('/Crop/search', { params });
  },

  checkVarietyExists: (varietyCode) =>
    api.get(`/Crop/variety/${encodeURIComponent(varietyCode)}/exists`)
};

export const authAPI = {
  login: (credentials) =>
    api.post('/Auth/login', credentials)
};

export const translationAPI = {
  // Start the translation batch process (fire-and-forget)
  startTranslation: () =>
    api.post('/Translation/start'),

  // Get translation service status
  getTranslationStatus: () =>
    api.get('/Translation/status')
};

export const qrCodeAPI = {
  generateQrCode: (varietyCode, options = {}) => {
    const params = new URLSearchParams({
      ...options,
      includeBranding: options.includeBranding !== false
    });
    return `${API_BASE_URL}/QrCode/${encodeURIComponent(varietyCode)}?${params}`;
  },

  getQrCodePreview: (varietyCode, options = {}) => {
    const params = new URLSearchParams(options);
    return `${API_BASE_URL}/QrCode/${encodeURIComponent(varietyCode)}/preview?${params}`;
  },

  downloadAllQrCodes: (options = {}) => {
    const params = new URLSearchParams({
      ...options,
      includeBranding: options.includeBranding !== false
    });
    return `${API_BASE_URL}/QrCode/download-all?${params}`;
  }
};

export default api;